import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { LayoutDashboard } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

// Componentes das versões
import Versao1021 from "./versoes/Versao1021";
import Versao1020 from "./versoes/Versao1020";
import Versao1019 from "./versoes/Versao1019";
import Versao1018 from "./versoes/Versao1018";
import Versao1017 from "./versoes/Versao1017";
import Versao1016 from "./versoes/Versao1016";
import Versao1014 from "./versoes/Versao1014";
import Versao1013 from "./versoes/Versao1013";
import Versao1011 from "./versoes/Versao1011";
import Versao1010 from "./versoes/Versao1010";

// Mapa das versões
const versoesMap = {
  "1.0.21": <Versao1021 />,
  "1.0.20": <Versao1020 />,
  "1.0.19": <Versao1019 />,
  "1.0.18": <Versao1018 />,
  "1.0.17": <Versao1017 />,
  "1.0.16": <Versao1016 />,
  "1.0.14": <Versao1014 />,
  "1.0.13": <Versao1013 />,
  "1.0.11": <Versao1011 />,
  "1.0.10": <Versao1010 />,
};

export default function TelaMelhorias() {
  const [versaoSelecionada, setVersaoSelecionada] = useState("1.0.21");

  return (
    <div
      className="p-6 flex flex-col flex-1 min-h-screen"
      style={{ fontFamily: "Comfortaa, cursive" }}
    >
      {/* Fonte Comfortaa */}
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        <link
          href="https://fonts.googleapis.com/css2?family=Comfortaa:wght@300..700&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      <nav className="flex items-center space-x-3 text-sm mb-6" aria-label="Breadcrumb">
        <LayoutDashboard size={16} className="text-slate-600" />
        <span className="text-slate-700 font-semibold">
          Melhorias e correção de bugs do sistema!
        </span>
      </nav>

      {/* QUADRO FLEXÍVEL — sem altura fixa */}
      <section className="bg-white rounded-md shadow-sm border border-[#4d4d4d] p-6 overflow-auto">
        <div className="flex items-center gap-6">

          <h2 className="text-lg font-semibold text-black">
            Selecione uma versão para poder ver as suas melhorias
          </h2>

          <select
            value={versaoSelecionada}
            onChange={(e) => setVersaoSelecionada(e.target.value)}
            className="px-3 py-2 rounded bg-white text-black border border-gray-400 focus:outline-none w-60"
          >
            <option value="1.0.21">Versão 1.0.21</option>
            <option value="1.0.20">Versão 1.0.20</option>
            <option value="1.0.19">Versão 1.0.19</option>
            <option value="1.0.18">Versão 1.0.18</option>
            <option value="1.0.17">Versão 1.0.17</option>
            <option value="1.0.16">Versão 1.0.16</option>
            <option value="1.0.14">Versão 1.0.14</option>
            <option value="1.0.13">Versão 1.0.13</option>
            <option value="1.0.11">Versão 1.0.11</option>
            <option value="1.0.10">Versão 1.0.10</option>
          </select>
        </div>

        <AnimatePresence mode="wait">
          <motion.div
            key={versaoSelecionada}
            initial={{ opacity: 0, y: 25 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -25 }}
            transition={{ duration: 0.35, ease: "easeOut" }}
            className="space-y-10 mt-10"
          >
            {versoesMap[versaoSelecionada]}
          </motion.div>
        </AnimatePresence>

      </section>
    </div>
  );
}
